import {Component, OnInit, ViewEncapsulation} from '@angular/core';
import {AuthentificationService} from './authentification.service';
import {TransactionsService} from './transactions.service';
import {SortTable} from './sort-table.component';
import {Sort} from '@angular/material';
import {AppComponent} from './app.component';
import {StocksService} from './stocks.service';

import {Router} from '@angular/router';

@Component({
    selector: 'app-enter-in-order-form-provider',
    templateUrl: './templates/enter-in-order-form-provider.component.html',
    styleUrls: ['./styles/enter-in-order-form-provider.component_news.css'],
    providers: [TransactionsService, AuthentificationService, SortTable, StocksService],
    encapsulation: ViewEncapsulation.None
})
export class EnterInOrderFormProviderComponent implements OnInit {
    session_mode: string = "RECEPTION";
    id_purchase_order: number = 0;
    bcf_details: any;
    bcf_name: string;
    bcf_receipt_list: any;
    validate_bt: boolean = true;
    disabled_input: boolean = true;
    bfc_validate: any = [];
    complete_infos: boolean = false;
    articles_list_popup: Array<any> = [];

    constructor(private app_component: AppComponent, private transactions_service: TransactionsService, private router: Router, private authentification_service: AuthentificationService, private sort_table: SortTable, private stock_service: StocksService) {
        this.CheckUSerSession();
       /* this.app_component.valTest = '/enter-bcf';
        this.app_component.GetParent();*/
    }

    CheckUSerSession(): void {

        this.authentification_service.UserCheckSession().then(result => {if (result['id_user'] === 0) {this.router.navigate(['authentification'])} });
    }

    GetSentPurchaseOrder() {
        this.transactions_service.GetSentPurchaseOrder().then(result => {this.bcf_receipt_list = result['list']; this.bfc_validate = result['list']; this.sort_table.SetDataArray(result['list'], [{value: "name", type: ""}, {value: "supplier", type: ""}, {value: "date", type: ""}, {value: "user", type: ""}]);});
    }

    SortValidate(sort: Sort): void {
        this.sort_table.sortData(sort);
        this.bfc_validate = this.sort_table.GetSortData();
        // recupérer  data
    }

    OrderDetails(bcf: any): void {
        this.id_purchase_order = bcf.id_purchase_order;
        this.bcf_name = bcf.name;
        //this.invalid_from = false;
        this.transactions_service.GetPurchaseOrderDetails(bcf.id_purchase_order).then(result => {this.bcf_details = result['list']; if (result['list'].length !== 0) {this.validate_bt = false} });
    }

    ValidateBcf(): void {
//        this.transactions_service.ValidateBcf(this.id_purchase_order, this.bcf_name).then(result => {this.bcf_details = result['list']; this.bcf_receipt_list = result['sent']; this.validate_bt = true; this.bcf_name = ""; this.bfc_validate = result['sent']; this.sort_table.SetDataArray(result['sent'], [{value: "name", type: ""}, {value: "supplier", type: ""}, {value: "date", type: ""}, {value: "user", type: ""}]); this.complete_infos = false; this.app_component.hide_wrapper(false);});
    }

    AddArticleInfos(): void {
      //  this.transactions_service.AddArticleInfos().then(result => {this.SessionModPopup(result['list']); this.TotalArticle(result['list']); this.articles_list_popup = result['list']; this.complete_infos = true; this.app_component.hide_wrapper(true);});
    }

    total_art: number = 0;
    TotalArticle(list: any): void {
        this.total_art = 0;
        for (let i = 0; i < list.length; i++) {
            this.total_art = this.total_art + parseInt(list[i]['qte_received']);
        }
    }

    EditArticleSessionPurchaseDetail(pannier: any): void {
      //  this.transactions_service.EditArticleSessionPurchaseDetailBcf(pannier.id_article).then(result => {this.bcf_details = result['list']; this.disabled_input = false; this.SessionMod(result['list'])});
    }

    LoadSessionPurchase() {
        this.transactions_service.GetSentPurchaseOrderDetails().then(session_list => {this.bcf_details = session_list['list']; if (session_list['list'].length !== 0) {this.validate_bt = false} });
    }

    EditAndValidateModification(prod: any): void {

        if (prod.status === "RECEPTION") {
            console.log(prod.status);
            //console.log(prod.id_article);
            this.EditArticleSessionPurchaseDetail(prod);
        } else if (prod.status === 'MODIFICATION') {
            console.log(prod.status);
            this.ValidateEditArticleSessionPurchaseDetail(prod);
        }

    }

    SessionMod(list: any): void {
        this.session_mode = "RECEPTION";
        for (let i = 0; i < list.length; i++) {
            if (list[i].status === "MODIFICATION") {
                this.session_mode = "MODIFICATION";
            }
        }
        //  console.log(this.session_mode);
    }

    session_mode_pop_up: string = "KO";
    SessionModPopup(list: any): void {
        this.session_mode_pop_up = "OK";
        for (let i = 0; i < list.length; i++) {
            if (list[i].serial_status === "KO") {
                this.session_mode_pop_up = "KO";
            }
        }


        //  console.log(this.session_mode);
    }

    ValidateEditArticleSessionPurchaseDetail(prod: any): void {
        console.log(prod);
        if (isNaN(prod.qte_received)) {
            prod.qte_received = "Valeur invalide";
            setTimeout(() => {this.LoadSessionPurchase()}, 3500);
        }
        else {
            this.transactions_service.ValidateEditArticleSessionPurchaseDetailBcf(prod).then(result => {this.bcf_details = result['list']; this.SessionMod(result['list'])});
        }
        //this.transactions_service.ValidateEditArticleSessionPurchase(prod).then(result => {this.pannier_list = result['list']; this.SessionMod(result['list'])});
    }

    Cancel(): void {
        this.complete_infos = false;
        this.app_component.hide_wrapper(false);
    }

    IsAvalableSerialNumber(article: any): void {
        console.log(article.serial);
        //this.ValidateForm();
        this.stock_service.IsAvalableSerialNumber(article).then(result => {this.articles_list_popup = result['list']; console.log(result['result']);});
    }

    ValidateForm(): void {
        var indices = [];
        var index = this.articles_list_popup.findIndex(article => article['serial'] === "Entrez le n° de série");

        /* console.log(index);
         console.log(indices);*/
    }

    ValidatePop(): void {
        this.ValidateBcf();
    }

    EditAndValidateModificationPopup(prod: any): void {
        //console.log(this.src_bt);

        //if (this.src_bt === "../../img/ico_modif.png") {prod.status === "RECEIPTION"
        if (prod.status === "RECEPTION") {
            //console.log(prod.id_article);
            this.EditArticleSessionPopup(prod);
        } else if (prod.status === 'MODIFICATION') {
            this.ValidateEditArticleSessionPopup(prod);
        }
    }

    EditArticleSessionPopup(prod: any): void {
        this.stock_service.EditArticleSessionReceiptBcf(prod.index).then(result => {this.articles_list_popup = result['list']; this.SessionModPopup(result['list'])});
    }

    ValidateEditArticleSessionPopup(prod: any): void {
        this.stock_service.ValidateEditArticleSessionReceiptPopup(prod).then(result => {this.articles_list_popup = result['list']; this.SessionModPopup(result['list'])});
    }

    ngOnInit() {
        this.GetSentPurchaseOrder();
    }

}



// WEBPACK FOOTER //
// ./src/app/enter-in-order-form-provider.component.ts